export function parseDate(date: any): Date | null {
  if (typeof date !== 'string') {
    return null;
  }
  const dateObj = new Date(date);
  try {
    dateObj.toISOString();
  } catch {
    return null;
  }
  return dateObj;
}
